import { Mail, Linkedin, Instagram, ArrowUp } from "lucide-react";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Book a Call", href: "#booking" },
    { label: "Contact", href: "#contact" },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      data-testid="footer"
      className="bg-foreground text-background py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2 space-y-4">
            <a href="/" className="group flex items-center gap-2 hover:opacity-90 transition-opacity">
              <span className="text-3xl font-bold text-primary" style={{ fontFamily: "'Dancing Script', cursive" }}>
                Thrive
              </span>
              <span className="text-xl font-medium text-background/80">
                with Deepa
              </span>
            </a>
            <p className="text-background/70 leading-relaxed max-w-md">
              Leadership and Career Coaching for mid-career professionals. 
              Building transformative partnerships to embrace health, confidence, 
              and joy.
            </p>
            <div className="flex gap-4">
              <a
                href="mailto:deepa.sa@gmail.com"
                data-testid="footer-email-link"
                className="p-2 bg-background/10 rounded-lg hover:bg-background/20 transition-colors"
                aria-label="Email"
              >
                <Mail className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com/deepa_coaching_thrive?igsh=MWRpY3lqMnV4OWl4Yw%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="p-2 bg-background/10 rounded-lg hover:bg-background/20 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin-link"
                className="p-2 bg-background/10 rounded-lg hover:bg-background/20 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-background/70 hover:text-background transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Contact</h3>
            <div className="space-y-2 text-background/70">
              <p>deepa.sa@gmail.com</p>
              <p>Sydney, Australia</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-background/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-background/50">
            © {currentYear} Deepa Coaching. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            data-testid="scroll-to-top-btn"
            className="p-2 bg-background/10 rounded-full hover:bg-background/20 transition-colors"
            aria-label="Scroll to top"
          >
            <ArrowUp className="h-5 w-5" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
